import Truck1 from "../agroImg/truck1.png";
import Truck2 from "../agroImg/truck2.png";
import Truck3 from "../agroImg/truck3.png";
import Truck4 from "../agroImg/truck4.png";
import Truck5 from "../agroImg/truck5.png";
import Truck6 from "../agroImg/truck6.png";
import Product1 from "../agroImg/pm1.png";
import Product2 from "../agroImg/pm2.png";
import Product3 from "../agroImg/pm3.png";
import Product4 from "../agroImg/pm4.png";
import Product5 from "../agroImg/pm5.png";
import Product6 from "../agroImg/pm6.png";
import Product7 from "../agroImg/pm7.png";

export const FeatureData = [
  {
    img: Truck1,
    greenCard: [
      {
        title: "John Deere",
        price: "$35,000",
      },
    ],
  },
  {
    img: Truck2,
    greenCard: [
      {
        title: "New Holland 6640 TL",
        price: "$60,000",
      },
    ],
  },
  {
    img: Truck3,
    greenCard: [
      {
        title: "Sonalika DI 75 RX Tractor",
        price: "$30,000",
      },
    ],
  },
  {
    img: Truck4,
    greenCard: [
      {
        title: "Mahindra",
        price: "$40,000",
      },
    ],
  },
  {
    img: Truck6,
    greenCard: [
      {
        title: "Massey Ferguson",
        price: "$50,000",
      },
    ],
  },
  {
    img: Truck5,
    greenCard: [
      {
        title: "New Holland 6640 TL",
        price: "$40,000",
      },
    ],
  },
  {
    img: Truck3,
    greenCard: [
      {
        title: "Sonalika DI 75 RX Tractor ",
        price: "$30,000",
      },
    ],
  },
  {
    img: Truck1,
    greenCard: [
      {
        title: "John Deere",
        price: "$35,000",
      },
    ],
  },
  {
    img: Truck5,
    greenCard: [
      {
        title: "Massey Ferguson",
        price: "$50,000",
      },
    ],
  },
  {
    img: Truck4,
    greenCard: [
      {
        title: "Mahindra",
        price: "$40,000",
      },
    ],
  },
  {
    img: Truck1,
    greenCard: [
      {
        title: "John Deere",
        price: "$35,000",
      },
    ],
  },
  {
    img: Truck2,
    greenCard: [
      {
        title: "New Holland 6640 TL",
        price: "$60,000",
      },
    ],
  },
  {
    img: Truck6,
    greenCard: [
      {
        title: "Sonalika DI 75 RX Tractor",
        price: "$30,000",
      },
    ],
  },
  {
    img: Truck3,
    greenCard: [
      {
        title: "Mahindra",
        price: "$40,000",
      },
    ],
  },
  {
    img: Truck1,
    greenCard: [
      {
        title: "Massey Ferguson",
        price: "$50,000",
      },
    ],
  },
  {
    img: Truck5,
    greenCard: [
      {
        title: "John Deere",
        price: "$35,000",
      },
    ],
  },
];

export const FeatureData2 = [
  {
    img: Product1,
    greenCard: [
      {
        title: "Clutch Pad",
        price: "$200",
      },
    ],
  },
  {
    img: Product2,
    greenCard: [
      {
        title: "Oil Filter",
        price: "$100",
      },
    ],
  },
  {
    img: Product3,
    greenCard: [
      {
        title: "Brake Pad",
        price: "$150",
      },
    ],
  },
  {
    img: Product4,
    greenCard: [
      {
        title: "Engine Oil",
        price: "$165",
      },
    ],
  },
  {
    img: Product5,
    greenCard: [
      {
        title: "Oil Filter",
        price: "$200",
      },
    ],
  },
  {
    img: Product6,
    greenCard: [
      {
        title: "Gear Oil",
        price: "$200",
      },
    ],
  },
  {
    img: Product7,
    greenCard: [
      {
        title: "Oil Filter",
        price: "$100",
      },
    ],
  },
  {
    img: Product1,
    greenCard: [
      {
        title: "Clutch Pad",
        price: "$200",
      },
    ],
  },
  {
    img: Product7,
    greenCard: [
      {
        title: "Oil Filter",
        price: "$100",
      },
    ],
  },
  {
    img: Product2,
    greenCard: [
      {
        title: "Oil Filter",
        price: "$100",
      },
    ],
  },
  {
    img: Product3,
    greenCard: [
      {
        title: "Brake Pad",
        price: "$150",
      },
    ],
  },
  {
    img: Product4,
    greenCard: [
      {
        title: "Engine Oil",
        price: "$165",
      },
    ],
  },
  {
    img: Product5,
    greenCard: [
      {
        title: "Oil Filter",
        price: "$200",
      },
    ],
  },
  {
    img: Product6,
    greenCard: [
      {
        title: "Gear Oil",
        price: "$200",
      },
    ],
  },
  {
    img: Product7,
    greenCard: [
      {
        title: "Oil Filter",
        price: "$100",
      },
    ],
  },
  {
    img: Product1,
    greenCard: [
      {
        title: "Clutch Pad",
        price: "$200",
      },
    ],
  },
];
